import React from "react";

export const usd = (n) => "$" + Math.round(n || 0).toLocaleString();
export const usdSigned = (n) => (n >= 0 ? "+" : "") + usd(n);
export const ROLES = ["CNA", "LPN", "RN"];
export const DIVISIONS = ["Facility", "GEM"];

export function monthLabel(key) {
  if (!key) return "";
  const [y, m] = key.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleString("en-US", { month: "short", year: "numeric", timeZone: "UTC" });
}

// Banner shown at the bottom of tabs whose data is not (yet) auto-refreshed.
export function StaticNote({ children }) {
  return (
    <div className="static-note">
      <span className="static-badge">Static data</span>
      {children || "These figures are entered manually and are not yet automated. We'll wire up an automated refresh later."}
    </div>
  );
}
